import { render, staticRenderFns } from "./ProjectInternalStaffManage.vue?vue&type=template&id=2b2fc31e&scoped=true&"
import script from "./ProjectInternalStaffManage.vue?vue&type=script&lang=js&"
export * from "./ProjectInternalStaffManage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInternalStaffManage.vue?vue&type=style&index=0&id=2b2fc31e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2fc31e",
  null
  
)

export default component.exports